import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import 'semantic-ui-css/semantic.min.css';
import App from './components/App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

import { createStore, applyMiddleware } from 'redux'
import allReducers from './reducers'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import 'babel-polyfill'
let store = createStore(allReducers, applyMiddleware(thunkMiddleware));


ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
//registerServiceWorker();
unregister()


// WEBPACK FOOTER //
// ./src/index.js